import styled from 'styled-components'

export const CloseButton = styled.button`
  position: absolute;
  @media(max-width: 768px) {
    position: fixed;
  }
  font-size: 35px;
  color: ${({ theme }) => theme.colors.text};
  background: transparent;
  margin-bottom: ${props => props.theme.spacing.small};
  margin-top: -10px;
  right: ${props => props.theme.spacing.medium};
  border: none;
  cursor: pointer;
  padding: 0;
`
